<template>
  <div>
    <installed-printer-edit-inline
      ref="installedEdit"
      @editPrinter="onEditPrinter"
    ></installed-printer-edit-inline>
    <network-printer-edit-inline
      ref="networkEdit"
      @editPrinter="onEditPrinter"
    ></network-printer-edit-inline>
    <bixolon-printer-edit-inline
      ref="bixolonEdit"
      @editPrinter="onEditPrinter"
    ></bixolon-printer-edit-inline>
  </div>
</template>

<script>
import { df } from '@/plugins/firebase'
import { v4 as uuidv4 } from 'uuid'
import { clone } from '@/plugins/utils'
import BixolonPrinterEditInline from '@/modules/point-of-sale/components/printer-configuration/Jspm/BixolonPrinterEditInline.vue'
import InstalledPrinterEditInline from '@/modules/point-of-sale/components/printer-configuration/Jspm/InstalledPrinterEditInline.vue'
import NetworkPrinterEditInline from '@/modules/point-of-sale/components/printer-configuration/Jspm/NetworkPrinterEditInline.vue'
export default {
  components: {
    BixolonPrinterEditInline, InstalledPrinterEditInline, NetworkPrinterEditInline
  },
  props: {
    location: {
      type: Object,
      required: true
    },
    company: {
      type: Object,
      required: true
    },
    printer: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tab: null,
      printers: [],
      printerToEdit: null
    }
  },
  computed: {
    isInstalled () {
      return this.printerToEdit && this.printerToEdit.library === 'UNIVERSAL' && !this.printerToEdit.ip_address
    },
    isNetwork () {
      return this.printerToEdit && this.printerToEdit.library === 'UNIVERSAL' && this.printerToEdit.ip_address
    },
    isBixolon () {
      return this.printerToEdit && (!this.printerToEdit.library || this.printerToEdit.library === 'BIXOLON')
    }
  },
  methods: {
    openPrinterEditDialog () {
      if (this.isInstalled) {
        this.$refs.installedEdit.open(this.printerToEdit)
      } else if (this.isNetwork) {
        this.$refs.networkEdit.open(this.printerToEdit)
      } else if (this.isBixolon) {
        this.$refs.bixolonEdit.open(this.printerToEdit)
      }
    },

    async getPrintersFromDatabase () {
      const printersRef = await df.collection(`location_printers/${this.location.id}/printers`).get()
      this.printers = printersRef.docs.map(doc => doc.data())
    },

    async onAddPrinter (printer) {
      await this.getPrintersFromDatabase()

      if (this.printers.findIndex(p => p.name === printer.name) === -1) {
        const printerId = uuidv4()
        const docRef = df.doc(`location_printers/${this.location.id}/printers/${printerId}`)

        try {
          await docRef.set(
            {
              id: printerId,
              name: printer.name,
              ip_address: printer.ipAddress,
              port: printer.port,
              printer_name: printer.printerName,
              library: printer.library,
              font: printer.font,
              size: printer.size,
              width: printer.width,
              line_length: printer.lineLength
            }
          )
          console.log('Printer successfully saved.')
        } catch (err) {
          console.error('Error saving printer: ', err)
        }
      }
      this.$emit('close')
    },
    async onEditPrinter (printer) {
      const docRef = df.doc(`location_printers/${this.location.id}/printers/${printer.id}`)

      try {
        await docRef.set(
          {
            id: printer.id,
            name: printer.name,
            ip_address: printer.ipAddress,
            port: printer.port,
            printer_name: printer.printerName,
            library: printer.library,
            font: printer.font,
            size: printer.size,
            width: printer.width,
            line_length: printer.lineLength,
            char_table: printer.charTable,
            code_page: printer.codePage,
            euro_symbol_type: printer.euroSymbolType
          }
        )
        console.log('Printer successfully saved.')
      } catch (err) {
        console.error('Error saving printer: ', err)
      }
      this.$emit('close')
    }
  },
  mounted () {
    this.printerToEdit = clone(this.printer)
    this.getPrintersFromDatabase()
    this.$nextTick(() => {
      this.openPrinterEditDialog()
    })
  }
}
</script>
